import React from 'react';
import AreaList from '../Area_list';
import ListFilter from '../../../components/ListFilter/filter';
import AreaEdit from '../Area_edit';
import Form from '../Form';
import L from 'leaflet';
import Moment from 'moment';
import Config from '../../../constants/appConfig';
import HangarIcon from '../../../assets/images/marker/waypoint/hangar.png';
import tools from '../../../components/util/tools';

import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DescriptionIcon from '@material-ui/icons/Description';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import PrintIcon from '@material-ui/icons/Print';
import SearchIcon from '@material-ui/icons/Search';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';

const parsePointsArea = (str) => {
  if (!str) return [];
  try {
    const arr = typeof str === 'string' ? JSON.parse(str) : str;
    if (!Array.isArray(arr)) return [];
    const pts = arr
      .filter(Array.isArray)
      .map(([lat, lng]) => [Number(lat), Number(lng)])
      .filter(([a, b]) => Number.isFinite(a) && Number.isFinite(b));
    if (pts.length >= 2) {
      const [f0, f1] = pts[0];
      const [l0, l1] = pts[pts.length - 1];
      if (f0 === l0 && f1 === l1) pts.pop();
    }
    return pts;
  } catch {
    return [];
  }
};

export default function ServiceSection(props) {
  const { ctx, res, profile, classes, link, serviceStatusOptions } = props;
  const readOnly = !ctx.state.editForm;
  const alertSaveFirst = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertSaveFirst === 'function') ctx.alertSaveFirst();
  };
  const alertReadOnly = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx?.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  return (
    <div style={{ display: ctx.state.tabValue === 1 ? 'flex' : 'none', flexDirection: 'column', marginTop: '1rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '1rem'
        }}
      >
        <h2 style={{ margin: 0 }}>{res.SERVICO}</h2>

        {!ctx.state.modalOpen && (
          <Button
            variant="contained"
            color="primary"
            className="popUpButton"
            disabled={
              ctx.state.id == null
                ? false
                : (
                  ctx.state.companyID === ctx.state.companyOriginID
                    ? !(ctx.state.share_status === 'criado' || ctx.state.share_status === 'retornado')
                    : ctx.state.share_status !== 'compartilhado'
                )
            }
            onClick={() => {
              ctx.setState({ editForm: true }, () => ctx.abrirModalTrabalho());
            }}
            style={{
              minWidth: 190,
              borderRadius: 8,
              textTransform: 'none',
              alignSelf: 'flex-end'
            }}
          >
            <AddIcon className="iconMapS" />
            {res.ADICIONAR_SERVICO}
          </Button>
        )}
      </div>

      {!ctx.state.modalOpen && (
        <Paper style={{ marginTop: '1rem', overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{res.DATA}</TableCell>
                <TableCell>{res.TITULO}</TableCell>
                <TableCell>{res.CULTURA}</TableCell>
                <TableCell>{res.TURNO_}</TableCell>
                <TableCell>{res.TIPO_APLICACAO}</TableCell>
                <TableCell>{res.CLASSE_AGROTOXICO}</TableCell>
                <TableCell>{res.TAMANHO_AREA}</TableCell>
                <TableCell>
                  {ctx.getTrabalho().typeApp && ctx.getTrabalho().typeApp.liquid ?
                    tools.replaceString(res._FLUXO, res.LINGUA === 'en-US' ? res.GALAP : res.LHA) :
                    ctx.getTrabalho().typeApp && ctx.getTrabalho().typeApp.solid ?
                      tools.replaceString(res._FLUXO, res.LINGUA === 'en-US' ? res.LBAC : res.KGHA) :
                      tools.replaceString(res._FLUXO, res.LINGUA === 'en-US' ? res.GALAP : res.LHA)}
                </TableCell>
                <TableCell>{tools.replaceString(res._FAIXA, res.LINGUA === 'en-US' ? res.P : res.M)}</TableCell>
                <TableCell>{res.STATUS}</TableCell>
                <TableCell align="center">{res.ACOES}</TableCell>
                <TableCell align="right" width="1%"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(ctx.state.jobsData || [])
                .map((trab, i) => {
                  const jobKey = trab?.guid || trab?.id_job || trab?.id;
                  const isExpanded = (ctx.state.expandedRows || []).includes(jobKey);

                  const idJob = trab?.id_job;
                  const areaScopeId = idJob ?? jobKey;

                  const tipoApp =
                    trab?.typeApp?.liquid ? res.LIQUIDO :
                      trab?.typeApp?.solid ? res.SOLIDO : '-';

                  const turno = [
                    trab?.turno?.manha ? res.MANHA : '',
                    trab?.turno?.tarde ? res.TARDE : ''
                  ].filter(Boolean).join('/') || '-';

                  const agroClassArr = [];
                  if (trab?.typeService?.insecticide) agroClassArr.push(res.INSETICIDA);
                  if (trab?.typeService?.herbicide) agroClassArr.push(res.HERBICIDA);
                  if (trab?.typeService?.fungicide) agroClassArr.push(res.FUNGICIDA);
                  if (trab?.typeService?.seeding) agroClassArr.push(res.SEMEADURA);
                  if (trab?.typeService?.fertilizing) agroClassArr.push(res.ADUBACAO);
                  if (trab?.typeService?.maturator) agroClassArr.push(res.MATURADOR);
                  const agroClass = agroClassArr.join(' / ') || '-';

                  const serviceMapping = {
                    AplicacaoAgrotoxico: res.APLICACAO_AGROTOXICO,
                    AplicacaoBioinsumo: res.APLICACAO_BIOINSUMO,
                    AplicacaoFertilizante: res.APLICACAO_FERTILIZANTE,
                    Semeadura: res.SEMEADURA,
                    Maturador: res.MATURADOR,
                    AplicacaoAdjuvante: res.APLICACAO_ADJUVANTE
                  };
                  const serviceTypeKey = String(trab?.selectedService || trab?.service_type || '').trim();
                  const serviceTypeText = serviceMapping[serviceTypeKey] || '-';

                  const eqMap = {
                    bicoHidraulicoCoreDisco: res.BICO_HIDRAULICO_CORE_DISCO,
                    bicoHidraulicoCeramica: res.BICO_HIDRAULICO_CERAMICA,
                    bicoHidraulicoSolido: res.BICO_HIDRAULICO_SOLIDO,
                    bicoHidraulicoPlano: res.BICO_HIDRAULICO_PLANO,
                    cp03tt03: res.CP03_TT03,
                    cp09tt09: res.CP09_TT09,
                    cp11tt11: res.CP11_TT11,
                    atomizadorTela: res.ATOMIZADOR_TELA,
                    atomizadorDisco: res.ATOMIZADOR_DISCO,
                    swathmaster: res.DIFUSOR_SOLIDOS,
                    outro: res.OUTROSTXT,
                  };
                  const eqType = trab?.equipment?.type ? (eqMap[trab.equipment.type] || trab.equipment.type) : '-';
                  const eqDet = trab?.equipment?.details || {};
                  const eqName = (trab?.equipment?.name || '').trim();

                  const risks = [];
                  if (trab?.areaRisk?.app) risks.push(res.APP);
                  if (trab?.areaRisk?.bee) risks.push(res.ABELHAS);
                  if (trab?.areaRisk?.others) {
                    const outroTxt = trab?.areaRistOutro ? ` (${trab.areaRistOutro})` : '';
                    risks.push((res.OUTROSTXT) + outroTxt);
                  }
                  const areaRiskTxt = risks.length ? risks.join(' / ') : '-';

                  const mapId = `map-area-${jobKey}`;
                  const toNum = (v) => {
                    if (v === null || v === undefined || v === '') return 0;
                    let s = String(v).replace(/[^\d,.\-]/g, '');
                    s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
                    const n = Number(s);
                    return isNaN(n) ? 0 : n;
                  };
                  const brl = (n) => Number(n || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

                  const areaHa = toNum(trab?.sizeArea);
                  const vHa = toNum(trab?.finance?.valuePerHa);
                  const gross = areaHa * vHa;
                  const dV = toNum(trab?.finance?.discountValue);
                  const dP = toNum(trab?.finance?.discountPercent);
                  const net = Math.max(gross - dV, 0);

                  const selectLatest = (arr = []) =>
                    arr.filter(Boolean).slice()
                      .sort((a, b) => new Date(b?.datetime || b?.startDate || 0) - new Date(a?.datetime || a?.startDate || 0))[0] || null;

                  const jobInfoExe = Array.isArray(trab?.list_exe) ? selectLatest(trab.list_exe) : null;
                  const jobInfoPlan = Array.isArray(trab?.list_plan) ? selectLatest(trab.list_plan) : null;
                  const jobInfo = jobInfoExe || jobInfoPlan;
                  const hasPlanOrExe = !!jobInfo;

                  const fmtDateTime = (v) => v ? Moment(v).format('DD/MM/YYYY HH:mm') : '-';
                  const safe = (v) => (v ?? '') === '' ? '-' : String(v);

                  const gridCols = hasPlanOrExe ? 5 : 4;
                  const gridStyle = { display: 'grid', gridTemplateColumns: `repeat(${gridCols}, minmax(0, 1fr))`, gap: '1rem' };
                  const titleCell = safe(jobInfoExe?.title || jobInfoPlan?.title || '-');
                  const hasPlan = Array.isArray(trab?.list_plan) && trab.list_plan.length > 0;
                  const hasExe = Array.isArray(trab?.list_exe) && trab.list_exe.length > 0;
                  const hasRelMapa =
                    !!trab?.predocument_b64 ||
                    !!trab?.documentRelMapab64 ||
                    (Array.isArray(trab?.list_relMapa) && trab.list_relMapa.some(rel => !!rel?.fileBase64));

                  return (
                    <React.Fragment key={jobKey}>
                      <TableRow hover>
                        <TableCell>{trab?.dateTimeTrabalho ? Moment(trab.dateTimeTrabalho).format('DD/MM/YYYY') : '-'}</TableCell>
                        <TableCell>{titleCell}</TableCell>
                        <TableCell>{trab?.cultura || '-'}</TableCell>
                        <TableCell>{turno}</TableCell>
                        <TableCell>{tipoApp}</TableCell>
                        <TableCell>{agroClass}</TableCell>
                        <TableCell>{trab?.sizeArea || '-'}</TableCell>
                        <TableCell>{trab?.fluxo || '-'}</TableCell>
                        <TableCell>{trab?.larguraFaixa || '-'}</TableCell>
                        <TableCell>{trab?.statusService || '-'}</TableCell>
                        <TableCell align="center">
                          <div style={{ display: 'inline-flex', gap: '0.25rem' }}>
                            {readOnly ? (
                              <>
                                <IconButton
                                  title={res.RELATORIO_MAPA}
                                  color={hasRelMapa ? 'primary' : 'default'}
                                  onClick={(e) => { link('/app/relatorio-mapa/edit/' + (trab?.id_job || '')); }}
                                  tabIndex={0}
                                  aria-disabled={false}
                                >
                                  <DescriptionIcon />
                                </IconButton>

                                <IconButton
                                  title={
                                    ctx.isPlanningButtonDisabled && ctx.isPlanningButtonDisabled()
                                      ? res.PLANEJAMENTO_PROCESSANDO
                                      : res.PLANEJAMENTO
                                  }
                                  color={hasPlan ? 'primary' : 'default'}
                                  disabled={ctx.isPlanningButtonDisabled && ctx.isPlanningButtonDisabled()}
                                  onClick={() => {
                                    if (ctx.isPlanningButtonDisabled && ctx.isPlanningButtonDisabled()) {
                                      return;
                                    }

                                    link(`/app/estimativa/edit/${hasPlan ? trab?.list_plan?.[0]?.guid : trab?.guid}`);
                                  }}
                                  tabIndex={0}
                                  aria-disabled={ctx.isPlanningButtonDisabled && ctx.isPlanningButtonDisabled()}
                                >
                                  <FlightTakeoffIcon />
                                </IconButton>

                                <IconButton
                                  title={res.RELATORIO_APLICACAO}
                                  color={hasExe ? 'primary' : 'default'}
                                  onClick={() => { link('/app/relatorio/' + (trab?.aplication_guid || '')); }}
                                  tabIndex={0}
                                  aria-disabled={false}
                                >
                                  <PrintIcon />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                <IconButton
                                  title={res.EDITAR}
                                  onClick={() => { ctx.abrirModalTrabalho(i); }}
                                  tabIndex={0}
                                  aria-readonly={false}
                                >
                                  <EditIcon />
                                </IconButton>

                                <IconButton
                                  title={res.EXCLUIR}
                                  onClick={() => { ctx.deleteJob(trab?.id); }}
                                  tabIndex={0}
                                  aria-readonly={false}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </>
                            )}
                          </div>
                        </TableCell>
                        <TableCell align="right" width="1%">
                          <IconButton
                            size="small"
                            onClick={() => ctx.toggleExpandRow(jobKey, trab)}
                            aria-label="expand row"
                          >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                          </IconButton>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <div style={{ background: '#f5f6f7', borderRadius: 8, padding: '1rem 1.25rem', margin: '0.25rem 0 1rem' }}>
                              <div style={gridStyle}>
                                <div>
                                  <div style={{ fontWeight: 600, marginBottom: 6 }}>{res.MAPA}</div>

                                  {(() => {
                                    const tabs = [
                                      { key: 'areaOS', label: res.AREA_OS },
                                      { key: 'planejamento', label: res.PLANEJAMENTO },
                                      { key: 'execucao', label: res.EXECUCAO },
                                    ];
                                    const currentKey = ctx.getAreaTab(areaScopeId);
                                    const value = Math.max(0, tabs.findIndex(t => t.key === currentKey));
                                    const isLoadingAreas = ctx.isJobAreasLoading(areaScopeId);

                                    return (
                                      <div style={{ marginBottom: 8 }}>
                                        <Tabs
                                          value={value}
                                          onChange={(_, idx) => ctx.setAreaTab(areaScopeId, tabs[idx].key)}
                                          TabIndicatorProps={{ style: { display: 'none' } }}
                                          sx={{
                                            backgroundColor: '#2c2c2c',
                                            borderRadius: '14px',
                                            padding: '2px',
                                            minHeight: 'unset',
                                            width: '100%',
                                            '& .MuiTabs-flexContainer': { flexWrap: 'wrap', gap: '4px' },
                                          }}
                                        >
                                          {tabs.map((t, index) => {
                                            const selected = value === index;
                                            const disabled = t.key !== 'areaOS' && isLoadingAreas;
                                            return (
                                              <Tab
                                                key={`${t.key}-${jobKey}`}
                                                label={t.label}
                                                disabled={disabled}
                                                style={{
                                                  textTransform: 'uppercase',
                                                  fontSize: '0.70rem',
                                                  fontWeight: 'bold',
                                                  borderRadius: '12px',
                                                  minHeight: 'unset',
                                                  lineHeight: 1.2,
                                                  padding: '4px 10px',
                                                  minWidth: 0,
                                                  flex: '0 0 auto',
                                                  color: selected ? '#fff' : (!disabled ? 'black' : '#b0b0b0'),
                                                  backgroundColor: selected ? '#3f51b5' : 'transparent',
                                                }}
                                              />
                                            );
                                          })}
                                        </Tabs>
                                      </div>
                                    );
                                  })()}

                                  {(() => {
                                    const currentTab = ctx.getAreaTab(areaScopeId);
                                    const apiAreas = ctx.getJobAreasById(areaScopeId);

                                    let polygons = [];
                                    if (currentTab === 'areaOS') {
                                      polygons = (Array.isArray(trab?.list_areas) ? trab.list_areas : [])
                                        .map(a => ({ name: a?.name || 'Área O.S', pts: parsePointsArea(a?.points_place || '[]') }))
                                        .filter(p => p.pts.length >= 3);
                                    } else {
                                      const list = Array.isArray(apiAreas?.[currentTab]) ? apiAreas[currentTab] : [];
                                      polygons = list
                                        .map(a => ({ name: a?.name || '-', pts: parsePointsArea(a?.points || '[]') }))
                                        .filter(p => p.pts.length >= 3);
                                    }

                                    const pointItem = Array.isArray(trab?.list_points)
                                      ? trab.list_points.find(p =>
                                        (typeof p.points_place === 'string' && p.points_place.trim() !== '') ||
                                        (p.lat != null && p.lng != null)
                                      )
                                      : null;

                                    const getRunwayLatLng = () => {
                                      if (!pointItem) return null;
                                      if (typeof pointItem.points_place === 'string' && pointItem.points_place.trim() !== '') {
                                        try {
                                          const parsed = JSON.parse(pointItem.points_place);
                                          const pair = Array.isArray(parsed) ? (Array.isArray(parsed[0]) ? parsed[0] : parsed) : null;
                                          if (pair && Number.isFinite(+pair[0]) && Number.isFinite(+pair[1])) return [+pair[0], +pair[1]];
                                        } catch { }
                                      }
                                      if (pointItem?.lat != null && pointItem?.lng != null) return [Number(pointItem.lat), Number(pointItem.lng)];
                                      return null;
                                    };
                                    const runwayLatLng = getRunwayLatLng();

                                    const fmt6 = (n) => (Number.isFinite(n) ? Number(n).toFixed(6) : '');
                                    const firstCenter = (() => {
                                      if (!polygons.length) return null;
                                      try { return L.latLngBounds(polygons[0].pts).getCenter(); } catch { return null; }
                                    })();
                                    const areaText = firstCenter ? `${fmt6(firstCenter.lat)}, ${fmt6(firstCenter.lng)}` : '';
                                    const pistaText = runwayLatLng ? `${fmt6(runwayLatLng[0])}, ${fmt6(runwayLatLng[1])}` : '';
                                    const distanceText = (() => {
                                      if (!firstCenter || !runwayLatLng) return '';
                                      const d = L.latLng(firstCenter.lat, firstCenter.lng).distanceTo(L.latLng(runwayLatLng[0], runwayLatLng[1]));
                                      return d < 1000 ? `${Math.round(d)} m` : `${(d / 1000).toFixed(1)} km`;
                                    })();

                                    return (
                                      <>
                                        <div style={{ display: 'flex', flexDirection: 'column', fontSize: 12, color: '#374151', marginBottom: 8 }}>
                                          <div><strong>{res.AREA}:</strong> {areaText}</div>
                                          <div><strong>{res.PISTA}:</strong> {pistaText}</div>
                                          <div><strong>{res.DISTANCIA}:</strong> {distanceText}</div>
                                        </div>

                                        {(polygons.length || runwayLatLng) ? (
                                          <div
                                            id={mapId}
                                            key={`map-${jobKey}-${currentTab}`}
                                            ref={(el) => {
                                              if (!el) return;

                                              if (el._leaflet_cleanup) { try { el._leaflet_cleanup(); } catch { } el._leaflet_cleanup = null; }
                                              if (el._leaflet_map) { try { el._leaflet_map.off(); el._leaflet_map.remove(); } catch { } el._leaflet_map = null; }
                                              if (el._leaflet_id) { try { delete el._leaflet_id; } catch { } }
                                              el.innerHTML = '';

                                              if (!document.getElementById('leaflet-fs-style')) {
                                                const st = document.createElement('style');
                                                st.id = 'leaflet-fs-style';
                                                st.textContent = `
                                                  .leaflet-container:fullscreen{width:100vw!important;height:100vh!important;background:#000;z-index:9999}
                                                  .leaflet-fullscreen-fallback{position:fixed!important;inset:0!important;width:100vw!important;height:100vh!important;z-index:9999!important;background:#000}
                                                  .leaflet-control-fullscreen a{width:26px;height:26px;line-height:26px;text-align:center;font-size:16px;font-weight:600}
                                                  .map-label{color:#fff;font-weight:700;font-size:12px;text-shadow:0 1px 2px rgba(0,0,0,.9),0 -1px 2px rgba(0,0,0,.9),1px 0 2px rgba(0,0,0,.9),-1px 0 2px rgba(0,0,0,.9);background:transparent;border:none;box-shadow:none;padding:0;margin:0;pointer-events:none}
                                                  .area-label .leaflet-tooltip-content{text-align:center}
                                                  .runway-label .leaflet-tooltip-content{text-align:center}
                                                `;
                                                document.head.appendChild(st);
                                              }

                                              const invalidateSizeSafe = (map) => {
                                                try {
                                                  if (!map) return;
                                                  if (!el.isConnected) return;
                                                  const panes = map._panes || {};
                                                  if (!panes.mapPane) return;
                                                  map.invalidateSize();
                                                } catch { }
                                              };

                                              const map = L.map(el, { zoomControl: false, attributionControl: false });
                                              el._leaflet_map = map;

                                              L.tileLayer(Config.tile_google, Config.tile_google_config).addTo(map);
                                              const bounds = L.latLngBounds([]);

                                              const currentTab2 = ctx.getAreaTab(areaScopeId);
                                              const apiAreas2 = ctx.getJobAreasById(areaScopeId);

                                              let polygons2 = [];
                                              if (currentTab2 === 'areaOS') {
                                                polygons2 = (Array.isArray(trab?.list_areas) ? trab.list_areas : [])
                                                  .map(a => ({ name: a?.name || 'Área O.S', pts: parsePointsArea(a?.points_place || '[]') }))
                                                  .filter(p => p.pts.length >= 3);
                                              } else {
                                                const list = Array.isArray(apiAreas2?.[currentTab2]) ? apiAreas2[currentTab2] : [];
                                                polygons2 = list
                                                  .map(a => ({ name: a?.name || '-', pts: parsePointsArea(a?.points || '[]') }))
                                                  .filter(p => p.pts.length >= 3);
                                              }

                                              const pointItem2 = Array.isArray(trab?.list_points)
                                                ? trab.list_points.find(p =>
                                                  (typeof p.points_place === 'string' && p.points_place.trim() !== '') ||
                                                  (p.lat != null && p.lng != null)
                                                )
                                                : null;

                                              let runwayLatLng2 = null;
                                              if (pointItem2) {
                                                if (typeof pointItem2.points_place === 'string' && pointItem2.points_place.trim() !== '') {
                                                  try {
                                                    const parsed = JSON.parse(pointItem2.points_place);
                                                    runwayLatLng2 = Array.isArray(parsed) ? (Array.isArray(parsed[0]) ? parsed[0] : parsed) : null;
                                                  } catch { }
                                                }
                                                if (!runwayLatLng2 && pointItem2?.lat != null && pointItem2?.lng != null) {
                                                  runwayLatLng2 = [Number(pointItem2.lat), Number(pointItem2.lng)];
                                                }
                                              }

                                              polygons2.forEach(({ name, pts }) => {
                                                try {
                                                  const poly = L.polygon(pts, { color: '#47839e', weight: 4, opacity: 0.5 }).addTo(map);
                                                  bounds.extend(poly.getBounds());
                                                  if (name) {
                                                    poly.bindTooltip(name, { permanent: true, direction: 'center', className: 'map-label area-label' }).openTooltip();
                                                  }
                                                } catch { }
                                              });

                                              if (runwayLatLng2) {
                                                const runwayIcon = L.icon({
                                                  iconUrl: HangarIcon,
                                                  iconSize: [32, 32],
                                                  iconAnchor: [16, 32],
                                                  tooltipAnchor: [0, -20],
                                                });

                                                const marker = L.marker(runwayLatLng2, {
                                                  title: pointItem2?.name,
                                                  icon: runwayIcon,
                                                }).addTo(map);
                                                bounds.extend(runwayLatLng2);
                                                if (pointItem2?.name) {
                                                  marker.bindTooltip(pointItem2.name, { permanent: true, direction: 'bottom', offset: [0, 12], className: 'map-label runway-label' }).openTooltip();
                                                }
                                              }

                                              if (bounds.isValid()) map.fitBounds(bounds, { padding: [10, 10] });
                                              else map.setView([0, 0], 2);

                                              map.whenReady(() => setTimeout(() => invalidateSizeSafe(map), 50));

                                              const supportsFS = !!(el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen);
                                              function isFullscreen() {
                                                return document.fullscreenElement === el ||
                                                  document.webkitFullscreenElement === el ||
                                                  document.mozFullScreenElement === el ||
                                                  document.msFullscreenElement === el ||
                                                  el.classList.contains('leaflet-fullscreen-fallback');
                                              }
                                              function requestFs(node) {
                                                try {
                                                  if (node.requestFullscreen) return node.requestFullscreen();
                                                  if (node.webkitRequestFullscreen) return node.webkitRequestFullscreen();
                                                  if (node.mozRequestFullScreen) return node.mozRequestFullScreen();
                                                  if (node.msRequestFullscreen) return node.msRequestFullscreen();
                                                } catch { } return Promise.resolve();
                                              }
                                              function exitFs() {
                                                try {
                                                  if (document.exitFullscreen) return document.exitFullscreen();
                                                  if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
                                                  if (document.mozCancelFullScreen) return document.mozCancelFullScreen();
                                                  if (document.msExitFullscreen) return document.msExitFullscreen();
                                                } catch { } return Promise.resolve();
                                              }

                                              const fullscreenOpen =
                                                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                                                '<path d="M3 9V3h6"/><path d="M21 9V3h-6"/><path d="M3 15v6h6"/><path d="M21 15v6h-6"/>' +
                                                '</svg>';
                                              const fullscreenOut =
                                                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                                                '<path d="M9 3v6H3"/><path d="M15 3v6h6"/><path d="M9 21v-6H3"/><path d="M15 21v-6h6"/>' +
                                                '</svg>';

                                              function updateBtnUI(btn) {
                                                const on = isFullscreen();
                                                btn.title = on ? 'Sair da tela cheia' : 'Tela cheia';
                                                btn.innerHTML = on ? fullscreenOut : fullscreenOpen;
                                                setTimeout(() => invalidateSizeSafe(map), 50);
                                              }
                                              function toggleFullscreen(btn) {
                                                if (supportsFS) {
                                                  if (!isFullscreen()) requestFs(el).then(() => invalidateSizeSafe(map));
                                                  else exitFs().then(() => invalidateSizeSafe(map));
                                                } else {
                                                  el.classList.toggle('leaflet-fullscreen-fallback');
                                                  setTimeout(() => invalidateSizeSafe(map), 50);
                                                }
                                                updateBtnUI(btn);
                                              }

                                              const FullscreenCtrl = L.Control.extend({
                                                options: { position: 'topright' },
                                                onAdd: function () {
                                                  const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-fullscreen');
                                                  const a = L.DomUtil.create('a', '', container);
                                                  a.href = '#'; a.setAttribute('aria-label', 'Tela cheia');
                                                  L.DomEvent.on(a, 'click', function (e) { L.DomEvent.stop(e); toggleFullscreen(a); });
                                                  L.DomEvent.disableClickPropagation(container);
                                                  L.DomEvent.disableScrollPropagation(container);
                                                  updateBtnUI(a);
                                                  return container;
                                                }
                                              });
                                              map.addControl(new FullscreenCtrl());

                                              function handleFSChange() {
                                                const nodes = el.getElementsByClassName('leaflet-control-fullscreen');
                                                if (nodes && nodes[0]) {
                                                  const link = nodes[0].getElementsByTagName('a')[0];
                                                  if (link) updateBtnUI(link);
                                                }
                                                setTimeout(() => invalidateSizeSafe(map), 100);
                                              }

                                              document.addEventListener('fullscreenchange', handleFSChange);
                                              document.addEventListener('webkitfullscreenchange', handleFSChange);
                                              document.addEventListener('mozfullscreenchange', handleFSChange);
                                              document.addEventListener('MSFullscreenChange', handleFSChange);

                                              el._leaflet_cleanup = () => {
                                                try {
                                                  document.removeEventListener('fullscreenchange', handleFSChange);
                                                  document.removeEventListener('webkitfullscreenchange', handleFSChange);
                                                  document.removeEventListener('mozfullscreenchange', handleFSChange);
                                                  document.removeEventListener('MSFullscreenChange', handleFSChange);
                                                } catch { }
                                                try { map.off(); map.remove(); } catch { }
                                              };

                                              setTimeout(() => invalidateSizeSafe(map), 300);
                                            }}
                                            style={{
                                              width: '100%',
                                              height: 260,
                                              borderRadius: 8,
                                              overflow: 'hidden',
                                              background: '#e9eef3',
                                              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.05)'
                                            }}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              height: 260, borderRadius: 8, border: '1px dashed #c9cdd3', background: '#fff',
                                              display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontWeight: 600
                                            }}
                                          >
                                            {res.SEM_AREA_E_PISTA}
                                          </div>
                                        )}
                                      </>
                                    );
                                  })()}
                                </div>

                                <div>
                                  <div style={{ fontWeight: 600, marginBottom: 6 }}>{res.DADOS}</div>
                                  <div><strong>{res.CLASSE_AGROTOXICO}:</strong> {agroClass}</div>
                                  <div><strong>{res.TIPO_SERVICO}:</strong> {serviceTypeText}</div>
                                  <div><strong>{res.AREA_RISCO}:</strong> {areaRiskTxt}</div>
                                  <div><strong>{res.AERONAVE}:</strong> {trab?.plane || '-'}</div>
                                  <div><strong>{res.PILOTO}:</strong> {trab?.pilot || '-'}</div>
                                  <div><strong>{res.ESPECTRO_GOTA}:</strong> {trab?.espGota || '-'}</div>
                                  <div><strong>{res.QUALIDADE_AGUA}:</strong> {trab?.qualidadeAgua || '-'}</div>
                                  <div><strong>{res.LITROS_KILOS}:</strong> {trab?.quantidadeLitrosKg || '-'}</div>
                                  <div style={{ marginTop: '0.5rem' }}>
                                    <strong>{res.EQUIPAMENTO}:</strong> {eqType}{eqName ? ` — ${eqName}` : ''}
                                  </div>
                                  <div>{res.DETALHES_EQUIPAMENTO}</div>
                                  {(eqDet.core || eqDet.disco || eqDet.angulo || eqDet.ponta || eqDet.anguloPa || eqDet.malha || eqDet.vru || eqDet.orificio)
                                    ? (
                                      <>
                                        {eqDet.core ? <div><strong>{res.CORE}:</strong> {eqDet.core}</div> : null}
                                        {eqDet.disco ? <div><strong>{res.DISCO}:</strong> {eqDet.disco}</div> : null}
                                        {eqDet.angulo ? <div><strong>{res.ANGULO}:</strong> {eqDet.angulo}</div> : null}
                                        {eqDet.ponta ? <div><strong>{res.PONTA}:</strong> {eqDet.ponta}</div> : null}
                                        {eqDet.anguloPa ? <div><strong>{res.ANGULO_PA}:</strong> {eqDet.anguloPa}</div> : null}
                                        {eqDet.malha ? <div><strong>{res.MALHA}:</strong> {eqDet.malha}</div> : null}
                                        {eqDet.vru ? <div><strong>{res.VRU}:</strong> {eqDet.vru}</div> : null}
                                        {eqDet.orificio ? <div><strong>{res.ORIFICIO}:</strong> {eqDet.orificio}</div> : null}
                                      </>
                                    )
                                    : <div>-</div>}
                                </div>

                                <div>
                                  <div style={{ fontWeight: 600, marginTop: 6 }}>{res.ITENS}</div>

                                  <div style={{ fontWeight: 600, marginTop: 6 }}>{res.PRODUTO}</div>
                                  {(() => {
                                    const toNum = (v) => {
                                      if (v === null || v === undefined || v === '') return 0;
                                      let s = String(v).replace(/[^\d,.\-]/g, '');
                                      s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
                                      const n = Number(s);
                                      return isNaN(n) ? 0 : n;
                                    };
                                    const getUnit = (p) => {
                                      const u = (p && (p.unit ?? p.measureUnit ?? p.unity)) || '';
                                      return String(u).toLowerCase();
                                    };
                                    const getDosage = (p) => {
                                      const d = p && (p.dosage ?? p.dose ?? p.rate);
                                      return toNum(d);
                                    };

                                    const areaHaLocal = toNum(trab?.sizeArea);
                                    const list = Array.isArray(trab?.list_prod) ? trab.list_prod : [];
                                    if (!list.length) return <Typography variant="body2">-</Typography>;

                                    return (
                                      <Paper variant="outlined" style={{ marginTop: 4, maxWidth: '100%', overflow: 'hidden' }}>
                                        <Table size="small" style={{ tableLayout: 'fixed', width: '100%', fontSize: 12 }}>
                                          <TableHead>
                                            <TableRow>
                                              <TableCell style={{ fontWeight: 700, width: '60%' }}>{res.NOME}</TableCell>
                                              <TableCell style={{ fontWeight: 700, width: '20%', textAlign: 'right' }}>{res.DOSAGEM}</TableCell>
                                              <TableCell style={{ fontWeight: 700, width: '20%', textAlign: 'right' }}>{res.TOTAL}</TableCell>
                                            </TableRow>
                                          </TableHead>

                                          <TableBody>
                                            {list.map((p, idxP) => {
                                              const unitRaw =
                                                (p && (p.unit ?? p.measureUnit ?? p.unity)) || '';
                                              const unitShort = unitRaw === 'l' ? 'L' : (unitRaw || 'kg');

                                              const d = p && (p.dosage ?? p.dose ?? p.rate);
                                              const toNum = (v) => {
                                                if (v === null || v === undefined || v === '') return 0;
                                                let s = String(v).replace(/[^\d,.\-]/g, '');
                                                s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
                                                const n = Number(s);
                                                return isNaN(n) ? 0 : n;
                                              };

                                              const dosage = toNum(d);
                                              const total = dosage * areaHaLocal;

                                              const dosageStr = dosage === 0 ? '-' : dosage.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
                                              const totalStr = total === 0 ? '-' : total.toLocaleString('pt-BR', { maximumFractionDigits: 2 });

                                              const name =
                                                (p && (p.name || p.description)) ||
                                                (p && (p.uid || p.code || p.id)) ||
                                                idxP;

                                              return (
                                                <TableRow key={`${jobKey}-prod-${p?.uid || p?.id || p?.code || idxP}`} hover style={{ lineHeight: 1.2 }}>
                                                  <TableCell
                                                    style={{
                                                      maxWidth: 0,
                                                      whiteSpace: 'normal',
                                                      overflowWrap: 'anywhere',
                                                      wordBreak: 'break-word',
                                                      paddingTop: 6,
                                                      paddingBottom: 6
                                                    }}
                                                    title={String(name)}
                                                  >
                                                    <Typography variant="body2" style={{ fontSize: 12 }}>
                                                      {String(name)}
                                                    </Typography>
                                                  </TableCell>

                                                  <TableCell
                                                    style={{
                                                      textAlign: 'right',
                                                      whiteSpace: 'nowrap',
                                                      paddingTop: 6,
                                                      paddingBottom: 6
                                                    }}
                                                  >
                                                    <Typography variant="body2" style={{ fontSize: 12 }}>
                                                      {dosageStr}{dosageStr !== '-' ? ` ${unitShort}` : ''}
                                                    </Typography>
                                                  </TableCell>

                                                  <TableCell
                                                    style={{
                                                      textAlign: 'right',
                                                      whiteSpace: 'nowrap',
                                                      paddingTop: 6,
                                                      paddingBottom: 6
                                                    }}
                                                  >
                                                    <Typography variant="body2" style={{ fontSize: 12 }}>
                                                      {totalStr}{totalStr !== '-' ? ` ${unitShort}` : ''}
                                                    </Typography>
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            })}
                                          </TableBody>
                                        </Table>
                                      </Paper>
                                    );
                                  })()}

                                  <div style={{ fontWeight: 600, marginTop: 6 }}>{res.FORMULACAO}</div>
                                  {(() => {
                                    const list = Array.isArray(trab?.list_form) ? trab.list_form : [];
                                    if (!list.length) return <Typography variant="body2">-</Typography>;
                                    return (
                                      <div>
                                        {list.map((f, idxF) => {
                                          const title =
                                            f?.name ||
                                            (f?.cod ? `${f.cod} - ${f?.description || ''}` : (f?.description || `#${f?.id || idxF}`));
                                          return (
                                            <Typography
                                              key={`${jobKey}-form-${f?.id || f?.cod || idxF}`}
                                              variant="body2"
                                              noWrap
                                              title={title}
                                            >
                                              • {title}
                                            </Typography>
                                          );
                                        })}
                                      </div>
                                    );
                                  })()}
                                </div>

                                <div>
                                  <div style={{ fontWeight: 600, marginBottom: 6 }}>{res.FINANCEIRO}</div>
                                  <div><strong>{res.VALOR_HA}:</strong> {brl(vHa)}</div>
                                  <div><strong>{res.VALOR_DESCONTO}:</strong> {brl(dV)}</div>
                                  <div><strong>{res.PERCENTUAL_DESCONTO}:</strong> {dP.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%</div>
                                  <div><strong>{res.VALOR_TOTAL_DESCONTO}:</strong> {brl(net)}</div>
                                </div>

                                {hasPlanOrExe && (
                                  <div>
                                    <div style={{ fontWeight: 600, marginBottom: 6 }}>
                                      {jobInfoExe ? (res?.EXECUTADO) : (res?.PLANEJAMENTO)}
                                    </div>

                                    <div><strong>{res.TITULO}:</strong> {safe(jobInfo.title)}</div>
                                    <div><strong>{res.PILOTO}:</strong> {safe(jobInfo.pilot)}</div>
                                    <div><strong>{res.AERONAVE}:</strong> {safe(jobInfo.plane)}</div>
                                    <div><strong>{res.AREA}:</strong> {safe(jobInfo.area_polygon)} ha</div>
                                    <div><strong>{jobInfoExe ? res.AREA_EXECUTADA : res.AREA_PLANEJADA} :</strong> {safe(jobInfo.area_spray)} ha</div>
                                    <div><strong>{res.LITROS}:</strong> {safe(jobInfo.liters)}</div>
                                    <div><strong>{res.DATA_INICIO}:</strong> {fmtDateTime(jobInfo.startDate)}</div>
                                    <div><strong>{res.DATA_FIM}:</strong> {fmtDateTime(jobInfo.endDate)}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
            </TableBody>
          </Table>
        </Paper>
      )}

      {ctx.state.modalOpen && (
        <Paper elevation={2} style={{ marginTop: '1rem', background: '#fff' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', backgroundColor: '#2D3238' }}>
            <div></div>
            <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>{res.CADASTRO_SERVICO}</h3>
            <CloseIcon onClick={ctx.fecharModalTrabalho} style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white' }} />
          </div>

          <div style={{ background: 'white', padding: '1rem 2rem 1.5rem' }}>
            <FormControl style={{ marginTop: '1rem', width: '12rem' }}>
              <InputLabel id="service-status-label">{res.STATUS}</InputLabel>
              <Select
                id="service-status"
                labelId="service-status-label"
                className={classes.selectHelp}
                value={ctx.getTrabalho().statusService || ''}
                onChange={ctx.onTrabalhoChange('statusService')}
                MenuProps={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  getContentAnchorEl: null
                }}
                displayEmpty
                renderValue={(v) => {
                  if (!v) return res.SELECIONE;
                  const opt = (serviceStatusOptions || []).find(o => o.value === v);
                  return opt?.label || v;
                }}
              >
                {(serviceStatusOptions || []).map((it) => (
                  <MenuItem key={it.value} value={it.value}>
                    <span style={{ display: 'inline-block', width: '100%' }}>
                      {it.label || it.value}
                    </span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ display: 'flex', marginTop: '0.5rem' }}>
              <TextField
                id="date-job"
                label={res.DATA_DO_TRABALHO}
                type="date"
                value={ctx.getTrabalho().dateTimeTrabalho}
                onChange={ctx.onTrabalhoChange('dateTimeTrabalho')}
                style={{ width: '12rem', marginBottom: '1rem', marginRight: '1rem' }}
                InputLabelProps={{ shrink: true }}
              />

              <FormControl
                style={{ width: '32rem', margin: '0 1rem 0 0' }}
                disabled={ctx.state.editData === false}
              >
                <InputLabel id="cultura-label" htmlFor="cultura" shrink>
                  {res.CULTURA}
                </InputLabel>

                <Select
                  labelId="cultura-label"
                  id="cultura"
                  value={ctx.getTrabalho().cultura || ''}
                  onChange={(e) =>
                    ctx.onTrabalhoChange('cultura')({
                      target: { value: String(e.target.value || '').slice(0, 45) },
                    })
                  }
                  displayEmpty
                  style={{ width: '100%' }}
                  endAdornment={
                    ctx.getTrabalho().cultura ? (
                      <IconButton
                        size="small"
                        style={{ marginRight: 24 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          ctx.onTrabalhoChange('cultura')({ target: { value: '' } });
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 224, width: 250 } },
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    getContentAnchorEl: null,
                  }}
                >
                  <MenuItem disabled value="">
                    {res.SELECIONAR_CULTURA}
                  </MenuItem>

                  {(ctx.state.cultureData || []).map((item) => (
                    <MenuItem key={item.name} value={item.name}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <div style={{ paddingTop: '1rem', marginRight: '2rem' }}>
                <span className="MuiFormLabel-root" style={{ fontSize: '16px' }}>{res.TURNO}</span>
                <Checkbox checked={!!ctx.getTrabalho().turno.manha} onClick={ctx.toggleTrabalhoCheck('turno', 'manha')} />
                <span onClick={ctx.toggleTrabalhoCheck('turno', 'manha')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.MANHA}</span>
                <Checkbox checked={!!ctx.getTrabalho().turno.tarde} onClick={ctx.toggleTrabalhoCheck('turno', 'tarde')} />
                <span onClick={ctx.toggleTrabalhoCheck('turno', 'tarde')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.TARDE}</span>
              </div>

              <div style={{ paddingTop: '1rem' }}>
                <span className="MuiFormLabel-root" style={{ fontSize: '16px' }}>{res.TIPO_APLICACAO}</span>
                <Checkbox checked={!!ctx.getTrabalho().typeApp.liquid} onClick={ctx.toggleTrabalhoCheck('typeApp', 'liquid')} />
                <span onClick={ctx.toggleTrabalhoCheck('typeApp', 'liquid')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.PRODUTO_LIQUIDO}</span>
                <Checkbox checked={!!ctx.getTrabalho().typeApp.solid} onClick={ctx.toggleTrabalhoCheck('typeApp', 'solid')} />
                <span onClick={ctx.toggleTrabalhoCheck('typeApp', 'solid')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.PRODUTO_SOLIDO}</span>
              </div>
            </div>

            <div style={{ display: 'flex' }}>
              <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <FormControl
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: '1rem',
                      width: '50%',
                      minWidth: 'max-content',
                      alignItems: 'center'
                    }}
                  >
                    <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>
                      {res.CLASSE_AGROTOXICO}:
                    </FormLabel>

                    {(() => {
                      const t = ctx.getTrabalho() || {};
                      const agro = (t.agroClass && typeof t.agroClass === 'object') ? t.agroClass : {};

                      return (
                        <>
                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.insecticide}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'insecticide')}
                                name="insecticide"
                              />
                            }
                            label={res.INSETICIDA}
                          />

                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.herbicide}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'herbicide')}
                                name="herbicide"
                              />
                            }
                            label={res.HERBICIDA}
                          />

                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.fungicide}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'fungicide')}
                                name="fungicide"
                              />
                            }
                            label={res.FUNGICIDA}
                          />

                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.seeding}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'seeding')}
                                name="seeding"
                              />
                            }
                            label={res.SEMEADURA}
                          />

                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.fertilizing}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'fertilizing')}
                                name="fertilizing"
                              />
                            }
                            label={res.ADUBACAO}
                          />

                          <FormControlLabel
                            style={{ margin: '0 0.5rem' }}
                            control={
                              <Checkbox
                                checked={!!agro.maturator}
                                onChange={ctx.toggleTrabalhoCheck('agroClass', 'maturator')}
                                name="maturator"
                              />
                            }
                            label={res.MATURADOR}
                          />
                        </>
                      );
                    })()}
                  </FormControl>
                  <div style={{ paddingTop: '1rem', display: 'flex', alignItems: 'center', width: '50%', minWidth: 'max-content' }}>
                    <span className="MuiFormLabel-root" style={{ fontSize: '16px' }}>{res.AREA_RISCO}</span>
                    <Checkbox checked={!!ctx.getTrabalho().areaRisk.app} onClick={ctx.toggleTrabalhoCheck('areaRisk', 'app')} />
                    <span onClick={ctx.toggleTrabalhoCheck('areaRisk', 'app')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.APP}</span>

                    <Checkbox checked={!!ctx.getTrabalho().areaRisk.bee} onClick={ctx.toggleTrabalhoCheck('areaRisk', 'bee')} />
                    <span onClick={ctx.toggleTrabalhoCheck('areaRisk', 'bee')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.ABELHAS}</span>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox checked={!!ctx.getTrabalho().areaRisk.others} onClick={ctx.toggleTrabalhoCheck('areaRisk', 'others')} />
                      <span onClick={ctx.toggleTrabalhoCheck('areaRisk', 'others')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>{res.OUTROSTXT}</span>

                      <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.5rem' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <TextField
                            id="areaRistOutro"
                            disabled={!ctx.getTrabalho().areaRisk.others}
                            value={ctx.getTrabalho().areaRisk.others ? (ctx.getTrabalho().areaRistOutro || '') : ''}
                            onChange={ctx.onTrabalhoChange('areaRistOutro')}
                            margin="normal"
                            onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45) }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <FormControl style={{ width: '100%', marginTop: '1rem' }}>
                    <InputLabel htmlFor="type-service">{res.TIPO_SERVICO}</InputLabel>
                    <Select
                      value={(ctx.getTrabalho() && ctx.getTrabalho().selectedService) || ''}
                      onChange={(e) => ctx.setTrabalhoValor('selectedService', e.target.value)}
                      style={{ width: '100%' }}
                      inputProps={{
                        name: 'typeService',
                        id: 'type-service',
                      }}
                      endAdornment={
                        ctx.getTrabalho() && ctx.getTrabalho().selectedService ? (
                          <IconButton
                            size="small"
                            style={{ marginRight: 24 }}
                            onClick={(e) => {
                              e.stopPropagation();
                              ctx.setTrabalhoValor('selectedService', '');
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        ) : null
                      }
                      MenuProps={{
                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem disabled value="">{res.SELECIONE_TIPO_SERVICO}</MenuItem>
                      <MenuItem value="AplicacaoAgrotoxico">{res.APLICACAO_AGROTOXICO}</MenuItem>
                      <MenuItem value="AplicacaoBioinsumo">{res.APLICACAO_BIOINSUMO}</MenuItem>
                      <MenuItem value="AplicacaoFertilizante">{res.APLICACAO_FERTILIZANTE}</MenuItem>
                      <MenuItem value="Semeadura">{res.SEMEADURA}</MenuItem>
                      <MenuItem value="Maturador">{res.MATURADOR}</MenuItem>
                      <MenuItem value="AplicacaoAdjuvante">{res.APLICACAO_ADJUVANTE}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>

            <div style={{ display: 'flex' }}>
              <FormControl style={{ marginTop: '1rem', width: '100%', paddingRight: '1rem' }}>
                <InputLabel>{res.AERONAVE}</InputLabel>
                <Select
                  multiple
                  id="plane"
                  value={(ctx.getTrabalho().plane || '').split(',').map((name) => String(name || '').trim()).filter(Boolean)}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(e) => {
                    ctx.applyPlaneConfigToJob(e.target.value || []);
                  }}
                  endAdornment={
                    ctx.getTrabalho().plane ? (
                      <IconButton
                        size="small"
                        style={{ marginRight: 24 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          ctx.applyPlaneConfigToJob([]);
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                  MenuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    getContentAnchorEl: null
                  }}
                >
                  {(Array.isArray(ctx.state.planes) ? ctx.state.planes : []).map((plane) => {
                    const selectedPlaneNames = (ctx.getTrabalho().plane || '').split(',').map((name) => String(name || '').trim()).filter(Boolean);
                    const planeName = String(plane.name || '').trim();
                    const isChecked = selectedPlaneNames.indexOf(planeName) >= 0;

                    return (
                      <MenuItem key={plane.id} value={planeName}>
                        <Checkbox checked={isChecked} />
                        {plane.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl style={{ marginTop: '1rem', width: '100%' }}>
                <InputLabel>{res.PILOTO}</InputLabel>
                <Select
                  multiple
                  id="pilot"
                  value={(ctx.getTrabalho().pilot || '').split(',').map((name) => name.trim()).filter(Boolean)}
                  renderValue={(selected) => selected.join(', ')}
                  onChange={(e) => {
                    const selectedNames = e.target.value || [];
                    const selectedPilots = (ctx.state.pilots || []).filter((pilot) => selectedNames.indexOf(pilot.name) >= 0);
                    const phones = [];
                    const canacs = [];
                    const emails = [];

                    selectedPilots.forEach((pilot) => {
                      const phone = pilot.phone || pilot.fone || pilot.cellphone || pilot.celular || pilot.telefone || pilot.whatsapp || '';
                      if (phone && phones.indexOf(phone) < 0) phones.push(phone);
                      if (pilot.canac && canacs.indexOf(pilot.canac) < 0) canacs.push(pilot.canac);
                      if (pilot.email && emails.indexOf(pilot.email) < 0) emails.push(pilot.email);
                    });

                    ctx.setTrabalhoValor('pilot', selectedNames.join(', '));
                    ctx.setTrabalhoValor('pilotId', null);
                    ctx.setTrabalhoValor('pilotPhone', phones.join(','));
                    ctx.setTrabalhoValor('pilotCanac', canacs.join(', '));
                    ctx.setTrabalhoValor('pilotEmail', emails.join(', '));
                  }}
                  endAdornment={
                    ctx.getTrabalho().pilot ? (
                      <IconButton
                        size="small"
                        style={{ marginRight: 24 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          ctx.setTrabalhoValor('pilot', '');
                          ctx.setTrabalhoValor('pilotId', null);
                          ctx.setTrabalhoValor('pilotPhone', '');
                          ctx.setTrabalhoValor('pilotCanac', '');
                          ctx.setTrabalhoValor('pilotEmail', '');
                        }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                >
                  {(Array.isArray(ctx.state.pilots) ? ctx.state.pilots : []).map((pilot) => (
                    <MenuItem key={pilot.id} value={pilot.name}>
                      <Checkbox checked={(ctx.getTrabalho().pilot || '').split(',').map((name) => name.trim()).filter(Boolean).indexOf(pilot.name) >= 0} />
                      {pilot.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                id="pilotCanac"
                label={res.CANAC}
                style={{ marginTop: '1rem', width: '100%', paddingRight: '1rem' }}
                value={ctx.getTrabalho().pilotCanac || ''}
                onChange={ctx.onTrabalhoChange('pilotCanac')}
              />

              <TextField
                id="pilotEmail"
                label={res.EMAIL}
                style={{ marginTop: '1rem', width: '100%' }}
                value={ctx.getTrabalho().pilotEmail || ''}
                onChange={ctx.onTrabalhoChange('pilotEmail')}
              />
            </div>

            <div style={{ display: 'flex' }}>
              <TextField
                id="sizeArea"
                label={res.TAMANHO_AREA}
                type="number"
                value={ctx.getTrabalho().sizeArea ?? ''}
                onChange={(e) => {
                  const value = e.target.value.toString().replace(',', '.');

                  if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                    return;
                  }

                  if (typeof ctx.setAreaHa === 'function') {
                    ctx.setAreaHa(value);
                  } else if (typeof ctx.onAreaChangeWithTotals === 'function') {
                    ctx.onAreaChangeWithTotals({
                      target: {
                        value: value
                      }
                    });
                  }
                }}
                margin="normal"
                fullWidth
                style={{ marginRight: '1rem' }}
                inputProps={{ step: '0.01', min: '0' }}
              />
              <TextField
                id="fluxo"
                label={
                  ctx.getTrabalho().typeApp && ctx.getTrabalho().typeApp.liquid ?
                    tools.replaceString(res._FLUXO_APLICACAO, res.LINGUA === 'en-US' ? res.GALAP : res.LHA) :
                    ctx.getTrabalho().typeApp && ctx.getTrabalho().typeApp.solid ?
                      tools.replaceString(res._FLUXO_APLICACAO, res.LINGUA === 'en-US' ? res.LBAC : res.KGHA) :
                      tools.replaceString(res._FLUXO_APLICACAO, res.LINGUA === 'en-US' ? res.GALAP : res.LHA)
                }
                type="number"
                value={ctx.getTrabalho().fluxo || ''}
                onChange={(e) => {
                  const value = e.target.value.toString().replace(',', '.');

                  if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                    return;
                  }

                  ctx.onTrabalhoChange('fluxo')({
                    target: {
                      value: value
                    }
                  });
                }}
                margin="normal"
                fullWidth
                style={{ marginRight: '1rem' }}
                inputProps={{ step: '0.01', min: '0' }}
              />
              <TextField
                id="larguraFaixa"
                label={tools.replaceString(res._LARGURA_FAIXA, res.LINGUA === 'en-US' ? res.P : res.M)}
                type="number"
                value={ctx.getTrabalho().larguraFaixa || ''}
                onChange={(e) => {
                  const value = e.target.value.toString().replace(',', '.');

                  if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                    return;
                  }

                  ctx.onTrabalhoChange('larguraFaixa')({
                    target: {
                      value: value
                    }
                  });
                }}
                margin="normal"
                fullWidth
                style={{ marginRight: '1rem' }}
                inputProps={{ step: '0.01', min: '0' }}
              />
              <TextField
                id="espGota"
                label={res.ESPECTRO_GOTA}
                value={ctx.getTrabalho().espGota || ''}
                onChange={ctx.onTrabalhoChange('espGota')}
                margin="normal"
                fullWidth
                onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45) }}
                style={{ marginRight: '1rem' }}
              />
              <TextField
                id="qualidadeAgua"
                label={res.QUALIDADE_AGUA}
                value={ctx.getTrabalho().qualidadeAgua || ''}
                onChange={ctx.onTrabalhoChange('qualidadeAgua')}
                margin="normal"
                fullWidth
                onInput={(e) => { e.target.value = e.target.value.toString().slice(0, 45) }}
                style={{ marginRight: '1rem' }}
              />
              <TextField
                id="quantidadeLitrosKg"
                label={res.LITROS_KILOS}
                type="number"
                value={ctx.getTrabalho().quantidadeLitrosKg || ''}
                onChange={(e) => {
                  const value = e.target.value.toString().replace(',', '.');

                  if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                    return;
                  }

                  ctx.onTrabalhoChange('quantidadeLitrosKg')({
                    target: {
                      value: value
                    }
                  });
                }}
                margin="normal"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
              />
            </div>

            <div>
              <FormControl style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem', width: '100%' }}>
                <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>{res.EQUIPAMENTO}:</FormLabel>
                <RadioGroup
                  style={{ display: 'flex', flexDirection: 'row' }}
                  value={ctx.getTrabalho().equipment?.type || ''}
                  onChange={(e) => ctx.onTrabalhoChange('equipment.type')(e)}
                >
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoCoreDisco" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_CORE_DISCO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoCeramica" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_CERAMICA} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoSolido" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_SOLIDO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="bicoHidraulicoPlano" control={<Radio color="primary" />} label={res.BICO_HIDRAULICO_PLANO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp03tt03" control={<Radio color="primary" />} label={res.CP03_TT03} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp09tt09" control={<Radio color="primary" />} label={res.CP09_TT09} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="cp11tt11" control={<Radio color="primary" />} label={res.CP11_TT11} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="atomizadorTela" control={<Radio color="primary" />} label={res.ATOMIZADOR_TELA} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="atomizadorDisco" control={<Radio color="primary" />} label={res.ATOMIZADOR_DISCO} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="swathmaster" control={<Radio color="primary" />} label={res.DIFUSOR_SOLIDOS} />
                  <FormControlLabel style={{ marginRight: '2rem' }} value="outro" control={<Radio color="primary" />} label={res.OUTROTXT} />
                </RadioGroup>
              </FormControl>
              {ctx.renderEquipmentDetailsInput()}
            </div>

            <div style={{ marginTop: '1rem' }}>
              {(() => {
                const pageSize = 12;
                const productFilter = (ctx.state.productFilter || '').toString();
                const page = Math.max(1, Number(ctx.state.productPage || 1));
                const allProducts = typeof ctx.getAllProducts === 'function' ? ctx.getAllProducts() : [];
                const filtered = allProducts.filter((p) =>
                  (p && p.name ? p.name : '').toLowerCase().includes(productFilter.toLowerCase())
                );
                const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
                const visible = filtered.slice((page - 1) * pageSize, page * pageSize);
                const selected = typeof ctx.getSelectedProducts === 'function' ? ctx.getSelectedProducts() : (ctx.getTrabalho().list_prod || []);

                return (
                  <>
                    <Paper variant="outlined" style={{ padding: '0.25rem 0.5rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0.75rem 0' }}>
                        <span>{res.LISTA_PRODUTOS}</span>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              borderBottom: '1px solid #000',
                              paddingBottom: 2,
                              marginRight: 8,
                            }}
                          >
                            <input
                              type="text"
                              placeholder={res.FILTRAR}
                              value={productFilter}
                              onChange={ctx.onProductFilterChange}
                              style={{
                                border: 'none',
                                outline: 'none',
                                fontSize: '0.75rem',
                                width: '6rem',
                                marginRight: 4,
                              }}
                            />
                            <SearchIcon fontSize="small" />
                          </div>

                          <IconButton
                            title={res.CADASTRAR}
                            aria-label="add"
                            onClick={ctx.openNewProductModal}
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          justifyContent: 'flex-start',
                          padding: 0,
                          margin: '0 -0.5rem'
                        }}
                      >
                        {visible.map((product) => {
                          const checked = selected.some(
                            (p) => (p && p.uid) === (product && product.uid)
                          );

                          const key =
                            product && product.uid
                              ? product.uid
                              : product && product.id
                                ? String(product.id)
                                : Math.random();

                          return (
                            <div
                              key={key}
                              style={{
                                padding: '0.5rem',
                                width: 'calc(33.33% - 1rem)',
                                boxSizing: 'border-box'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                <Checkbox
                                  checked={!!checked}
                                  onChange={() => ctx.toggleProductSelect(product)}
                                  style={{ padding: 0, marginRight: '0.5rem' }}
                                />
                                <span
                                  style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}
                                >
                                  {product && product.name ? product.name : ''}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8 }}>
                        <IconButton size="small" onClick={() => ctx.onProductPage(-1, totalPages)} disabled={page <= 1}>
                          <ChevronLeftIcon />
                        </IconButton>
                        <div style={{ fontSize: 12, minWidth: 60, textAlign: 'center' }}>
                          {page} / {totalPages}
                        </div>
                        <IconButton size="small" onClick={() => ctx.onProductPage(1, totalPages)} disabled={page >= totalPages}>
                          <ChevronRightIcon />
                        </IconButton>
                      </div>
                    </Paper>

                    {selected.length > 0 && (
                      <div style={{ marginTop: '0.75rem', border: '1px solid gray', padding: '0.25rem' }}>
                        <span>{res.PRODUTOS_SELECIONADOS}</span>

                        {selected.map((p, idxSel) => (
                          <div
                            key={p && p.uid ? p.uid : (p && p.id ? String(p.id) : String(idxSel))}
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr 140px 160px 160px',
                              gap: 8,
                              alignItems: 'center',
                              border: '1px solid #e0e0e0',
                              borderRadius: 8,
                              padding: 8,
                              marginTop: 6
                            }}
                          >
                            <div title={p && p.name ? p.name : ''} style={{ fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              <Checkbox checked onChange={() => ctx.toggleProductSelect(p)} style={{ padding: 0, marginRight: 8 }} />
                              {(p && p.name) || ''}
                            </div>

                            <TextField
                              select
                              label={res.UNIDADE}
                              value={p && p.unit ? String(p.unit).toLowerCase() : ''}
                              onChange={(e) => ctx.setProductUnit(idxSel, e.target.value)}
                              SelectProps={{
                                displayEmpty: true,
                                renderValue: (val) =>
                                  val === '' ? <span style={{ opacity: 0.6 }}>{res.SELECIONE}</span>
                                    : (val === 'l' ? res.LITROS : res.KG)
                              }}
                              InputLabelProps={{ shrink: true }}
                              margin="normal"
                              fullWidth
                            >
                              <MenuItem value="">{res.SELECIONE}</MenuItem>
                              <MenuItem value="l">{res.LITROS}</MenuItem>
                              <MenuItem value="kg">{res.KG}</MenuItem>
                            </TextField>

                            <TextField
                              label={res.DOSAGEM}
                              type="number"
                              value={p && p.dosage != null ? p.dosage : ''}
                              onChange={(e) => {
                                const value = e.target.value.toString().replace(',', '.');

                                if (value !== '' && !/^\d*\.?\d*$/.test(value)) {
                                  return;
                                }

                                ctx.setProductDosage(idxSel, value);
                              }}
                              margin="normal"
                              fullWidth
                              inputProps={{ step: '0.01', min: '0' }}
                            />

                            <TextField
                              label={res.TOTAL}
                              value={p && p.total ? Number(p.total).toLocaleString('pt-BR', { maximumFractionDigits: 2 }) : ''}
                              margin="normal"
                              fullWidth
                              InputProps={{ readOnly: true }}
                            />
                          </div>
                        ))}

                      </div>
                    )}
                  </>
                );
              })()}
            </div>

            <div style={{ marginTop: '1rem' }}>
              <Form
                key={`form-${ctx.state.editIndex ?? 'novo'}`}
                res={res}
                link={link}
                list={ctx.getTrabalho().list_form || []}
                update={(itens) => { ctx.setTrabalhoValor('list_form', [...itens]); ctx.setState({ isRel: false }); }}
                add={ctx.addList('list_form', 'list_all_form')}
              />
            </div>

            <div style={{ display: 'flex', gap: '1rem' }}>
              <div style={{ width: '50%', flexGrow: 1 }}>
                <AreaList
                  key={`areas-${ctx.state.editIndex ?? 'novo'}`}
                  res={res}
                  link={link}
                  list={ctx.getTrabalho().list_areas || []}
                  type={res.POLIGONOS}
                  showPolyType
                  update={(items) => {
                    const novo = [...items];
                    ctx.setTrabalhoValor('list_areas', novo);
                    if (typeof ctx.computeAndSetSizeArea === 'function') ctx.computeAndSetSizeArea(novo);
                    if (typeof ctx.recomputeSelectedProductsTotals === 'function') ctx.recomputeSelectedProductsTotals();
                  }}
                  upload={(event) => {
                    ctx.type_import = 'Polygons';
                    if (typeof ctx.captureAreaFilesToAttachments === 'function') ctx.captureAreaFilesToAttachments(event);
                    ctx.loadFile(event);
                    if (event?.target) event.target.value = '';
                  }}
                  legacyUpload={ctx.loadFileWithListFilter}
                  hasSavedImport={ctx.lastImportedGeoFeatures.length > 0}
                  openSavedImport={ctx.openLastImportedGeoPreview}
                  edit={(guid) => { ctx.type_import = 'Polygon'; ctx.showEditArea('list_areas')(guid); }}
                />
              </div>
              <div style={{ width: '50%', flexGrow: 1 }}>
                <AreaList
                  res={res}
                  list={ctx.getTrabalho().list_points || []}
                  type={res.PISTAS}
                  update={(items) => { ctx.setTrabalhoValor('list_points', items); }}
                  upload={(event) => {
                    ctx.type_import = 'Points';
                    if (typeof ctx.captureAreaFilesToAttachments === 'function') {
                      ctx.captureAreaFilesToAttachments(event);
                    }
                    ctx.loadFile(event);
                    if (event?.target) event.target.value = '';
                  }}
                  edit={(guid) => { ctx.type_import = 'Point'; ctx.showEditArea('list_points')(guid); }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
              <Button variant="contained" onClick={ctx.fecharModalTrabalho} className="popUpButton">
                {res.CANCELAR}
              </Button>
              <Button onClick={ctx.serviceOrderJobs} color="primary" variant="contained">
                {res.SALVAR}
              </Button>
            </div>
          </div>
        </Paper>
      )}

      <div id="divPro" className="sr-only back-drop" style={{ backgroundColor: '#fff', zIndex: 599 }}>
        <div className="in-back-drop" style={{ position: 'fixed' }}>
          <CircularProgress color="inherit" disableShrink />
        </div>
      </div>

      <ListFilter
        res={res}
        onClose={ctx.onCloseFilterArea}
        itens={ctx.state.import.itens}
        open={ctx.state.import.show}
        index={1003}
        listFilter={ctx.state.import.update}
        selected={ctx.state.import.selected}
      />

      <Dialog onClose={ctx.onCloseEditArea} aria-labelledby="simple-dialog-title" open={ctx.state.edit.show}>
        <AreaEdit
          res={res}
          onClose={ctx.onCloseEditArea}
          type={ctx.type_import}
          item={ctx.state.edit.item}
          update={ctx.updateArea(ctx.state.edit.update)}
          registeredAreas={ctx.state.registeredAreas}
          registeredAreaClients={ctx.state.registeredAreaClients}
          registeredAreaProperties={ctx.state.registeredAreaProperties}
          registeredAreaFolders={ctx.state.registeredAreaFolders}
          registeredAreasByClient={ctx.state.registeredAreasByClient}
          onRegisteredAreaClientChange={ctx.handleRegisteredAreaClientChange}
          runways={ctx.state.runways}
        />
      </Dialog>

      <Dialog open={!!ctx.state.newProductModalOpen} onClose={ctx.closeNewProductModal} aria-labelledby="dlg-new-prod" fullWidth maxWidth="sm">
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', backgroundColor: '#2D3238' }}>
            <div></div>
            <h3 style={{ margin: 0, color: 'white', whiteSpace: 'nowrap' }}>{res.NOVO_PRODUTO}</h3>
            <CloseIcon onClick={ctx.closeNewProductModal} style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white' }} />
          </div>
          <div style={{ padding: '1rem 2rem' }}>
            <TextField
              autoFocus
              margin="dense"
              label={res.NOME}
              fullWidth
              value={ctx.state.newProductName || ''}
              onChange={ctx.onNewProductNameChange}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', padding: '0 2rem 1rem' }}>
            <Button onClick={ctx.closeNewProductModal} disabled={!!ctx.state.newProductSaving}>
              {res.CANCELAR}
            </Button>
            <Button
              onClick={() => {
                const name = (ctx.state.newProductName || '').trim();
                if (!name) return;

                ctx.saveNewProductCustom();

                const now = Date.now();
                const newProd = { id: now, name, active: 1, source: 'custom', is_custom: true, uid: `custom:${now}` };

                const selected = Array.isArray(ctx.getTrabalho().list_prod) ? [...ctx.getTrabalho().list_prod] : [];
                if (!selected.some(p => (p.name || '').toLowerCase() === name.toLowerCase())) {
                  selected.push(newProd);
                  ctx.setTrabalhoValor('list_prod', selected);
                }

                ctx.closeNewProductModal();
              }}
              color="primary"
              variant="contained"
              disabled={!String(ctx.state.newProductName || '').trim() || !!ctx.state.newProductSaving}
              startIcon={ctx.state.newProductSaving ? <CircularProgress size={16} /> : null}
            >
              {res.SALVAR}
            </Button>
          </div>
        </div>
      </Dialog>

    </div>
  );
}
